import React from 'react';
import { ReactComponent as MyReports } from '../../../assets/my-reports.svg';
import { ReactComponent as SettingsIcon } from '../../../assets/settings.svg';
import { ReactComponent as TransactionsIcon } from '../../../assets/transactions.svg';
import { ReactComponent as HelpIcon } from '../../../assets/help.svg';
import { ReactComponent as CheckPlan } from '../../../assets/checkforplan.svg';
import { ReactComponent as CheckBenefit } from '../../../assets/checkforbenefit.svg';
import { ReactComponent as Info } from '../../../assets/info.svg';
import { ReactComponent as PreCheck } from '../../../assets/precheck.svg';

const Icon = ({ name, color, size = 20, ...props }) => {
    const icons = {
        myReports: MyReports,
        settings: SettingsIcon,
        transactions: TransactionsIcon,
        help: HelpIcon,
        CheckPlan: CheckPlan,
        CheckBenefit: CheckBenefit,
        Info: Info,
        PreCheck: PreCheck,
    };

    const SelectedIcon = icons[name];

    if (!SelectedIcon) {
        console.warn(`Icon "${name}" not found!`);
        return null;
    }

    return <SelectedIcon fill={color} width={size} height={size} {...props} />;
};

export default Icon;
